import "../css/newLogin.css";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
import { createRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputMask } from "primereact/inputmask";
import { Toast } from "primereact/toast";
import CryptoJS from 'crypto-js';
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Countdown from "react-countdown";
import { apiClient } from "../apiClient";
import { useOnlineStatus } from "../context/OnlineContext";
import colors from '../colors';

const toast = createRef();

function NewLogin()
{

    const config = {headers: { "Content-Type": "application/json" }};
    const [loginError,setLoginError]= useState("");
    const navigate = useNavigate();
    const [verificationCode,setVerificationCode] = useState();
    const [step,setStep] = useState(1);
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    const [codeSent,setCodeSent] = useState(false);
    const [user,setUser] = useState();
    const [resendAvailable, setResendAvailable] = useState(false);
    const { online, setOnline } = useOnlineStatus();

    const convertPersianToEnglish = (str) => {
      const persianNumbers = ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹'];
      const englishNumbers = ['0','1','2','3','4','5','6','7','8','9'];
    
      return str.replace(/[۰-۹]/g, (char) => englishNumbers[persianNumbers.indexOf(char)]);
    };


    //send verifivation code:
    const handleSendCode = () => {
      
            const phone = phoneForm.values.phone.replace(/[^0-9]+/g, "");
            const vCode = Math.floor(Math.random() * 9000) + 1000;


            //send verification code:
            setVerificationCode(vCode);
      
                var d = JSON.stringify({
                  "code": "zf2eweyd8aycp54",
                  "sender": "+983000505",
                  "recipient": phone,
                  "variable": {
                    "verification-code": vCode
                  }
                });
      
      
                var config1 = {
                  method: 'post',
                  url: 'https://api2.ippanel.com/api/v1/sms/pattern/normal/send',
                  headers: { 
                    'apikey': 'bv1PxCuaPVZUcIPOSqgmx7u9w8nzdBk1Boj_vnwvo48=', 
                    'Content-Type': 'application/json'
                  },
                  data : d
                };
      
                apiClient(config1)
                .then(function (response) {
                  
                  if(response.status === 200)
                  {
                    toast.current.show({
                        severity: "success",
                        detail: "کد تایید به شماره همراه شما ارسال شد",
                      });
                    setCodeSent(true);
                    
                    setResendAvailable(false); // Disable resending while the timer is running
                  }
                  
                })
                .catch(function (error) {
                  console.log("error",error);
                
                });
      
            //check if user has registred before:
            apiClient.get(process.env.REACT_APP_BACK+"/users/check-phone/"+phone, config)
            .then(async (response) => {
      
              await setUser(response.data);
              

            })
            .catch((error) => {
              console.log(error);
              // toast.current.show({
              //   severity: "error",
              //   detail: "کاربر با این شماره تلفن ثبت نشده است. لطفا ثبت نام کنید",
              // });
              setStep(1);
              setCodeSent(false);
      
              
            });


      
    };
  
    const handleResendCode = () => {
      handleSendCode();
    };
  
    const renderer = ({ minutes, seconds, completed }) => {
      if (completed) {
        // Enable the "Resend Code" button after the timer ends
        setResendAvailable(true);
        return <span>Time expired. You can resend the code now.</span>;
      } else {
        // Show the countdown timer
        return (
          <span>
            {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
          </span>
        );
      }
    };
 

         const encryptData = (message) => {
            const secretKey = process.env.REACT_APP_ACCESS_JWT_SECRET;
          
            if (!secretKey) {
                throw new Error("Encryption key is missing!");
            }
        
            // 🔹 Ensure key is 32 bytes
            const key = CryptoJS.enc.Utf8.parse(secretKey.padEnd(32, ' '));
        
            const encrypted = CryptoJS.AES.encrypt(message, key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
        
            return encrypted;
        };
        
      
        const phoneForm = useFormik({
          initialValues: {
            phone: "",
          },
          validate: (values) =>
          {
      
            let errors={}
      
            if(!values.phone)
              errors.phone = "لطفاً شماره موبایل را وارد کنید";
      
      
            return errors;
      
         
        },
          onSubmit: (values) => {
      
      
            //send verification code by sms:      
            handleSendCode();
                
          },
        });
      
        const vCodeForm = useFormik({
          initialValues: {
            vCode: "",
          },
          validate: (values) =>
          {
            let errors={};
      
            if(!values.vCode)
              errors.vCode = "لطفاً کد تایید را وارد کنید";
      
            return errors;
      
         
          },
          onSubmit: async (values) =>  {
      
      
            //check if timer has passed, step back:
            if(codeSent && resendAvailable)
            {
              
              toast.current.show( {
                severity: "error",
                detail: "زمان ارسال کد خاتمه یافته. لطفاً دوباره تلاش کنید"});
                
                setCodeSent(false);
                setResendAvailable(false);


              return;
            }
    
            //check if verification code is the same:
            if(values.vCode == verificationCode)
            {
              
              let tempUser=user;
            
                //register user(not registered before):
                if (user==="" || !user)
                {
              
                    //creating user in database
                    const config = {     
                        headers: { 
                        'Content-Type': 'application/json'
                    }
                    }
                    const data = JSON.stringify({ role:"subscriber" ,phone:phoneForm.values.phone.replace(/[^0-9]+/g, "")});
                    
                    await apiClient.post(process.env.REACT_APP_BACK+"/users/register", data, config)
                        .then(async (response) => 
                        {
                            if (response.status == 201)
                            {
                              tempUser={_id:response.data._id, role:response.data.role };
                                await setUser(tempUser);
                                          
                          }
                        })
                        .catch(error => {
                          console.log(error);
                                });
                            
                            
                    
                        }
                        else  //user already registered:
                        {

                        }


                        //cache user:
                        localStorage.setItem("seo_app", JSON.stringify(tempUser));
                       
                                  
                        //ask for user token:
                      const payload = {payload:encryptData(tempUser._id+","+tempUser.role)};
                      apiClient.post(process.env.REACT_APP_BACK+"/users/getToken/", JSON.stringify(payload), config)
                      .then((response2) => 
                      {
                        
                        if(response2.status === 201)
                        {
          
                          localStorage.setItem("userToken", JSON.stringify(response2.data));
                          // Set online status to true
                          setOnline(true);
                          
                        }
                        
                      })
                      .catch(function (error) {
                        console.log("error",error);
                    
                      });
                
                         //user can now login:
                         if(user.role === "manager")
                          navigate("/manager-dashboard");
                        else
                          navigate("/dashboard", { state: { user: tempUser }});
      
             
            }
            else
            {
              
      
              toast.current.show({
                severity: "error",
                detail: "کد صحیح نبود. لطفا مجدداً تلاش کنید",
              });
              setCodeSent(false);
            }     
            
            
            vCodeForm.resetForm();

          },
        });

        

    return (
        <div>

                    <Toast ref={toast}  life="5000" position="center center" className="custom-toast"/>
 
                      {/* before sending code */}
                      <form id="code-notsent" onSubmit={phoneForm.handleSubmit} style={{display : !codeSent ? "block" : "none" }}>
                       
                      <div style={{marginTop:"40px",direction:"rtl",textAlign:"right"}}><label>
                      شماره موبایل:
                        </label></div>
                   
                      <div style={{textAlign:'right'}}>    

                      <span style={{ border:"1px solid rgba(0, 0, 0, 0.22)", padding: "5px", display: "flex",
                            borderRadius: "10px", marginTop: "10px",gap:"10px"}}>
                        
                        <InputMask 
                        id="phone"
                        name="phone"
                        mask="(0999) 9999999" 
                        value={phoneForm.values.phone}
                        onChange={phoneForm.handleChange}
                        style={{ direction: "ltr", textAlign: "left", width:"100%",border:"none" }}
                        placeholder="(0919)999-99-99"
                        className={phoneForm.errors["phone"] ? "p-invalid" : null}
                        ></InputMask>

                        <span style={{background:"rgba(0, 0, 0, 0.06)",padding:"5px",direction:"ltr",fontSize:"14px",display:"flex",
                            alignItems:"center",borderRadius:"10px",gap:'10px'}}>
                                <img src={require("../images/Flag_of_Iran.svg.png")} 
                                style={{width:"30px",height:"20px",objectFit:"cover"}}
                                alt={process.env.REACT_APP_ALT}
                                ></img>
                                +98</span>

                      </span>
        
                      <small className="p-error">{phoneForm.errors["phone"]}</small>
        
                      </div>
        
                    <div style={{marginBottom:"40px",marginTop:"30px"}}>
                      <Button type="submit" label="ورود یا ثبت نام"  style={{width:"100%",borderRadius:"10px"}} />
                      </div>

                     
                      </form>
        
        
        
        
        
                    {/* after sending code */}
                   <form onSubmit={vCodeForm.handleSubmit} className="p-fluid" style={{display : codeSent ? "block" : "none" }} >
        
                   <div id="code-sent">
                
                   <span style={{fontSize:"12px",color:'#219B9D',cursor:'pointer',fontFamily: 'peyda-bold'}} 
                            onClick={ () => navigate("/login")}><i className="pi pi-pencil" 
                            style={{fontSize:"12px",marginLeft:'5px',fontWeight: "bold",marginBottom:'5px'}}></i>تغییر شماره
                            </span>
                        <p>
                            {"کد تایید به شماره  "+
                          phoneForm.values.phone.replace(/[^0-9]+/g, "")+
                            "ارسال شد  "}
                        </p>
                        
                      </div>
                   
                   <div style={{marginTop:"40px",direction:"rtl",textAlign:"right"}}><label>کد تایید:</label></div>
                   
                   <div style={{marginBottom:"10px"}}>
                    <InputText 
                    name="vCode" 
                    id="vCode"
                    value={vCodeForm.values.vCode}
                    onChange={(e) => {
                      const fixedValue = convertPersianToEnglish(e.target.value);
                      vCodeForm.setFieldValue("vCode", fixedValue);
                    }}
                    label="ویرایش" 
                    style={{borderColor:"#404040b8",borderRadius:"10px"}} 
                    className={vCodeForm.errors["vCode"] ? "p-invalid" : null}
                    />

                    {/* <InputOtp value={vCodeForm.values.vCode} onChange={vCodeForm.handleChange} integerOnly mask/> */}
        
                     <small className="p-error">{vCodeForm.errors["vCode"]}</small>
        
                    </div>
                   
                   <div style={{marginBottom:"10px"}}><Button className="filled-button" type="submit" label="ادامه"  style={{width:"100%"}} /></div>
                   </form>


                    <div id="refresh-container">
                    {codeSent && (
                      
                      <div style={{cursor: !resendAvailable ? "not-allowed" : "pointer"}}>
                        
                        <i className="pi pi-sync resfresh-icon" ></i>
                        
                        { !resendAvailable && <Countdown 
                          date={Date.now() + 90000} 
                          renderer={renderer}
                           />}

                        
                        <button
                          onClick={handleResendCode}
                          disabled={!resendAvailable}
                          style={{ marginTop: "10px",cursor: resendAvailable ?  "pointer" : null}}
                          id="refresh-botton"
                          
                        >
                          {!resendAvailable ?
                          "دقیقه"
                          :"ارسال مجدد کد"
                          }
                        </button>
                      </div>
                    )}
                   </div>
        
        
        
                    </div>
    );

}

export default NewLogin;